import { CSSProperties } from 'react';

export const blockContainer: CSSProperties = {
  backgroundColor: '#FFFFFF',
  borderRadius: '14px',
  boxShadow: '0 2px 12px rgba(0, 0, 0, 0.04)',
  border: '1px solid rgba(0, 0, 0, 0.03)'
};

export const menuTextStyle: CSSProperties = {
  fontSize: '15px',
  fontWeight: '400',
  color: '#1A1A1A'
};

export const menuItemStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  padding: '18px 16px',
  cursor: 'pointer',
  borderBottom: '1px solid rgba(0, 0, 0, 0.04)'
};

export const subtitleStyle: CSSProperties = {
  fontSize: '13px',
  color: '#8B8B8E',
  marginTop: '3px',
  maxWidth: '230px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  fontWeight: '400'
};
